
import { Datagrid, List, Pagination, ReferenceField, TextField } from "react-admin";
import { ReportFilter } from "./ReportFilter";
import { ShowConversationForReportButton } from "./ShowConversationForReportButton";
import { ShowMessagesForReportButton } from "./ShowMessagesForReportButton";
import { DateTimeField } from "@/src/components";


const ReportPagination = () => <Pagination rowsPerPageOptions={[25, 50, 100]} />;
const dataGridSx = {
    '& .RaDatagrid-headerCell': {
        padding: "4px 8px 4px 8px",
    },
    '& .RaDatagrid-rowCell': {
        padding: "4px 8px 4px 8px",
    },
    '& .RaDatagrid-checkbox': {
        padding: "4px 8px 4px 8px",
    },
    '& .column-conversation': {
        padding: "0px 0px 0px 0px",
        textAlign: "center",
    },
    '& .column-messages': {
        padding: "0px 0px 0px 0px",
        textAlign: "center",
    }
}
export const ReportList = () => (
    <List
        perPage={25}
        pagination={<ReportPagination />}
        sort={{ field: 'createdAt', order: 'DESC' }}
        filters={<ReportFilter />}
        exporter={false}
    >
        <Datagrid bulkActionButtons={false} sx={dataGridSx}>
            {/* <TextField source="id" /> */}
            <ReferenceField label="Reporter" source="reporter" reference="user">
                <TextField source="profile.nickname" />
            </ReferenceField>
            <ReferenceField label="About" source="about" reference="user">
                <TextField source="profile.nickname" />
            </ReferenceField>
            <ShowConversationForReportButton label="Chat" source="conversation" />
            <ShowMessagesForReportButton label="Msg" source="messages" />
            <TextField source="subject" />
            {/* <TextField source="body" /> */}
            <DateTimeField source="createdAt" />

        </Datagrid>
    </List>
);
